module.exports = __webpack_public_path__ + "static/img/wireframe-img-02@t.67a04f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/wireframe-img-02@t.png
// module id = XNI+
// module chunks = 0